<div class="p-maintenance">
    <span class="p-maintenance__logo">
        <img src="../../../assets/img/logo_opco_ep.png" alt="opco ep">
    </span>
    <div class="p-maintenance__content">
        <h1 class="main-text">
            {{maintenance?.title}}
        </h1>
        <h2 class="sub-text" [innerHTML]="maintenance?.message"></h2>
    </div>
</div>
 <div class="p-maintenance__footer">
       Copyright &copy; 2021 - {{currentYear}} OPCO EP - Tous droits réservés
 </div>